interface FilesFilters {
  file_type: string | null
  model_type: string | null
  date_range: string | null
}

const EMPTY_FILES_FILTERS: FilesFilters = {
  file_type: null,
  model_type: null,
  date_range: null
}

export { EMPTY_FILES_FILTERS }
export type { FilesFilters }
